import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import CookieService from "../../context/cookies";

import { base } from "../../constants/apis";

export interface AccessControlRes {
  status: string;
  count: number;
  records: AccessControlRecord[];
}

export interface AccessControlRecord {
  id: number;
  uid: number;
  email: string;
  child_uid: number;
  table_id: number;
  shared: "viewer" | "editor";
  created_at: string;
}

export const accessControlApi = createApi({
  reducerPath: "accessControlApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${base}/apis/access_control`,
    prepareHeaders: (headers) => {
      const token = CookieService.getCookie("jwtToken");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  tagTypes: ["AccessControl"],

  endpoints: (builder) => ({
    getAccessControlList: builder.query<AccessControlRes, void>({
      query: () => "/get.php",
      providesTags: ["AccessControl"],
    }),

    addAccessControl: builder.mutation({
      query: (body) => ({
        url: "/add.php",
        method: "POST",
        body,
      }),

      // OPTIMISTIC UPDATE
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // 1️⃣ Apply optimistic update
        const patch = dispatch(
          accessControlApi.util.updateQueryData(
            "getAccessControlList",
            undefined,
            (draft) => {
              draft.records.push({
                id: Date.now(), // temporary ID
                ...arg,
              });
            }
          )
        );

        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },

      invalidatesTags: ["AccessControl"],
    }),

    updateAccessControl: builder.mutation({
      query: (body) => ({
        url: "/update.php",
        method: "POST",
        body,
      }),
      invalidatesTags: ["AccessControl"],
    }),
  }),
});

export const {
  useGetAccessControlListQuery,
  useAddAccessControlMutation,
  useUpdateAccessControlMutation,
} = accessControlApi;
